module.exports = __webpack_public_path__ + "img/group_code_bg@2x.8b8b560a.png";